import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import moment from "moment";

export function errorMessageForHasDeadline(
  locationType: LocationType,
  hasDeadline: boolean | undefined,
) {
  // Only allow deadlines for distribution warehouses and trade shows
  if (
    locationType !== LocationType.DistributionWarehouse &&
    locationType !== LocationType.TradeShow
  ) {
    return undefined;
  }

  if (hasDeadline === undefined) {
    return `Required`;
  }

  return undefined;
}

export function locationsErrorMessageForDeadline(
  pickupDate: string,
  hasDeadline: boolean | undefined,
  deadlineDate: string | undefined,
  earliestDeliveryDate: string | undefined,
): ErrorMessageType {
  if (!hasDeadline) {
    return undefined;
  }

  if (hasDeadline && deadlineDate === undefined) {
    return "Required";
  }

  const pickupMoment = moment(pickupDate).startOf("day");
  const deadelineMoment = moment(deadlineDate).startOf("day");

  if (!deadelineMoment.isAfter(pickupMoment)) {
    return "Deadline must be after pickup date";
  }

  if (
    earliestDeliveryDate !== undefined &&
    deadelineMoment.isBefore(moment(earliestDeliveryDate).startOf("day"))
  ) {
    return "Deadline cannot be before the carrier's earliest delivery date";
  }

  return undefined;
}
